import type { ReactNode } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { useLanguage } from "@/i18n";

/**
 * Drone imagery, property outlines and editable layers -- the three upload
 * panels -- in one large dialog, instead of a strip that pushed the map down.
 */
export default function ManageUploadsDialog({
  open,
  onOpenChange,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
}) {
  const { t } = useLanguage();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[90vh] w-[min(96vw,1200px)] max-w-none flex-col p-5">
        <DialogTitle className="text-base">{t.workspace.manageUploads}</DialogTitle>
        <DialogDescription>{t.workspace.manageUploadsHint}</DialogDescription>
        <div className="thin-scroll mt-4 grid min-h-0 flex-1 grid-cols-1 gap-3 overflow-y-auto md:grid-cols-2 xl:grid-cols-3">
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
}
